// extracted by mini-css-extract-plugin
export default {"container":"WeatherlyLogo_container__9BzEV","container__heading":"WeatherlyLogo_container__heading__U4ryu"};